import { render, staticRenderFns } from "./FootLinks.vue?vue&type=template&id=f63959b8&"
import script from "./FootLinks.vue?vue&type=script&lang=js&"
export * from "./FootLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports